import React, { useState } from "react";
import BorderColorOutlinedIcon from "@mui/icons-material/BorderColorOutlined";
import VisibilityOffOutlinedIcon from "@mui/icons-material/VisibilityOffOutlined";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import { message } from "antd";
import TextStyles from "../../../../../../Constants/TextStyles";
import Styled from "../../PageOne/PageOne";
import { useDispatch, useSelector } from "react-redux";
import { updateProjectTerminationNoticePeriodPC } from "../../../../../../store/service/proposalAndContractService";
import TermAndTerminationModal from "../../PageModals/TermAndTerminationModal.jsx";
import Colors from "../../../../../../Constants/Colors";

const TermAndTermination = () => {
  const selectedData = useSelector(
    (state) => state.proposalAndContract.selectedData
  );
  const [showModal, setShowModal] = useState(false);
  const dispatch = useDispatch();

  const defaultHeading = "Term & Termination";
  const defaultParagraph =
    "Additionally, either Party may terminate the Agreement immediately if the other Party fails to remedy a breach within 5 days of receiving written notice of such breach.  If Client terminates the Agreement without cause, Client agrees to compensate Contractor for services provided and expenses already incurred up to the termination date, including documented non-cancellable commitments. Contractor will make efforts to minimize these costs and expenses. Termination will not affect Client's rights granted under this Agreement. The Client must pay all undisputed amounts owed to the Contractor upon termination. If Client hasn't paid undisputed fees for services or materials provided by Contractor as of the termination date, Client may not use such materials until payment is made in full. Any provisions in this Agreement that imply survival shall remain in effect after termination or expiration. Notwithstanding other terms, Contractor retains a perfected security interest in the deliverables or materials until Client pays all undisputed amounts in full. Contractor will release and waive the security interest upon receipt of full payment for all undisputed amounts.";

  const heading =
    selectedData &&
    selectedData.term_and_termination &&
    selectedData.term_and_termination.heading
      ? selectedData.term_and_termination.heading
      : defaultHeading;
  const paragraph =
    selectedData &&
    selectedData.term_and_termination &&
    selectedData.term_and_termination.heading
      ? selectedData.term_and_termination.paragraph
      : defaultParagraph;

  const terminationNoticePeriod =
    selectedData &&
    selectedData.term_and_termination &&
    selectedData.term_and_termination.project_termination_notice_period
      ? selectedData.term_and_termination.project_termination_notice_period
      : "14 days";

  const isTermAndTerminationRequired =
    selectedData &&
    selectedData.term_and_termination &&
    selectedData.term_and_termination.required
      ? true
      : false;

  const toggleTermAndTerminationViewHandler = () => {
    const Obj = {
      _id: selectedData._id,
      term_and_termination: {
        required: !isTermAndTerminationRequired,
        heading,
        paragraph,
        project_termination_notice_period: terminationNoticePeriod,
      },
    };
    dispatch(updateProjectTerminationNoticePeriodPC(Obj)).then((data) => {
      if (data.meta.requestStatus === "fulfilled") {
        message.success(
          isTermAndTerminationRequired
            ? "Clause hidden successfully!"
            : "Clause unhidden successfully!"
        );
      } else {
        message.error(`${data.error.message}!`);
      }
    });
  };

  return (
    <div>
      <Styled.ReviewContentBox className="mt-4">
        <div className="edit-delete-icons">
          <span onClick={toggleTermAndTerminationViewHandler}>
            {isTermAndTerminationRequired ? (
              <VisibilityOffOutlinedIcon
                sx={{
                  cursor: "pointer",
                  color: Colors.font2,
                  opacity: 0.8,
                  "&:hover": {
                    opacity: 1,
                  },
                }}
              />
            ) : (
              <VisibilityOutlinedIcon
                sx={{
                  cursor: "pointer",
                  color: Colors.font2,
                  opacity: 0.8,
                  "&:hover": {
                    opacity: 1,
                  },
                }}
              />
            )}
          </span>

          {isTermAndTerminationRequired && (
            <BorderColorOutlinedIcon
              sx={{
                cursor: "pointer",
                color: Colors.font2,
                opacity: 0.8,
                marginLeft: 2,
                "&:hover": {
                  opacity: 1,
                },
              }}
              onClick={() => setShowModal(true)}
            />
          )}
        </div>

        <TextStyles.FontSize20px className="mb-3 overflow-hidden">
          <span
            className={`fw-medium ${
              isTermAndTerminationRequired ? "" : "disabled"
            }`}
          >
            {heading}
          </span>
        </TextStyles.FontSize20px>

        <TextStyles.FontSize14px
          className={`lh-lg overflow-hidden ${isTermAndTerminationRequired ? "" : "disabled"}`}
          style={{ whiteSpace: "break-spaces" }}
        >
          <div className="mb-2">
            Either Party has the right to terminate this Agreement at any time
            by providing
            <span
              className="mx-2 fw-semibold"
            >
              {terminationNoticePeriod}
            </span>
            written notice, with or without cause.
          </div>
          {paragraph}
        </TextStyles.FontSize14px>
      </Styled.ReviewContentBox>
      {showModal && (
        <TermAndTerminationModal
          paragraph={paragraph}
          heading={heading}
          defaultHeading={defaultHeading}
          defaultParagraph={defaultParagraph}
          show={showModal}
          handleClose={() => setShowModal(false)}
        />
      )}
    </div>
  );
};

export default TermAndTermination;
